export default __webpack_public_path__ + "static/media/SpinHeroes.cbf94fec.jpg";